import cn from "classnames"
import React from "react"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { Routemap } from "@/common/routes"
import { ProfileOutline, ProductsOutline, ChevronDown } from "@/skylticons"

interface ShellProps {
  customer?: string
  profile?: boolean
  orders?: boolean
  children?: React.ReactNode
}

const Shell: React.FC<ShellProps> = ({ customer, profile, orders, children }) => {
  const { t } = useTranslation()

  return (
    <div className="customerzone">
      {customer && (
        <div>
          <div className="logout float-right text-right">
            <p className="paragraph-sm mb-0">{t("customer.loggedin")}:</p>
            <p className="paragraph-sm data-hj-suppress mb-0" id="customerid">
              {customer}
            </p>
            <a href={Routemap.customerZoneLogout(t)} className="button button-primary button-medium logout-link mb-0">
              {t("customer.log_out")}
            </a>
          </div>
          <Link to={Routemap.customerZone(t)} className={cn("customertab orders static", { active: orders })}>
            <ProductsOutline />
            <span className="name hidden sm:inline">{t("customer.orders")}</span>
            <span className="name sm:hidden">{t("customer.orders_short")}</span>
            <ChevronDown className="arrow" aria-hidden />
          </Link>
          <Link to={Routemap.customerZoneProfile(t)} className={cn("customertab profile static", { active: profile })}>
            <ProfileOutline />
            <span className="name hidden sm:inline">{t("customer.profile")}</span>
            <span className="name sm:hidden">{t("customer.profile_short")}</span>
            <ChevronDown className="arrow" aria-hidden />
          </Link>
        </div>
      )}
      <div className="clear-both">{children}</div>
    </div>
  )
}

export default Shell
